import http from "../http-common";

class LockedDataService {
  getAll(payload) {
    const { filter } = payload;

    const keyword =
      filter?.search === "" || filter?.search === undefined
        ? "?keyword="
        : `?keyword=${filter?.search}`;
    return http.get(`/api/v1/backoffice/accounts/locked/list${keyword}`);
  }
}

export default new LockedDataService();
